module.exports = __webpack_public_path__ + "static/media/Soothing.06f8305f.m4a";